module.exports = __webpack_public_path__ + "img/player-pause-blue.a6ee6034.svg";